import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { LoginPasswordlessPage } from './login-passwordless.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
  ],
  declarations: [LoginPasswordlessPage],
  exports: [LoginPasswordlessPage],
})
export class LoginPasswordlessPageModule {}
